module.exports = __webpack_public_path__ + "static/media/om_beard_long_diamond__v_shadow.454bd1c9.png";